import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "core/store";

const companyReducer = (state: RootState) => state.company;

export const companyIdCompanySelector = createSelector(
	companyReducer,
	(state) => {
		return state.idCompany;
	}
);

export const companyDetailsSelector = createSelector(
	companyReducer,
	(state) => {
		return state.companyDetails;
	}
);

export const idClienteSelector = createSelector(companyReducer, (state) => {
	return state.idCliente;
});
